import SkeletonStack from '@/components/shared/loader/skeleton-stack';

const FilterOptionsLoader = () => (
  <SkeletonStack
    count={4}
    className="min-w-20 grow h-4 rounded-sm"
    wrapperClassName="flex flex-col gap-4"
  />
);

export default FilterOptionsLoader;
